/**
 * PWA Initializer Component
 * Client-side component to initialize PWA features
 */

import { useEffect } from "react";
import { initializePWA } from "~/lib/offline/pwa.client";

export function PWAInitializer() {
  useEffect(() => {
    initializePWA().catch(console.error);
  }, []);

  return null; // This component doesn't render anything
}
